import { Link } from '@reach/router';
import * as React from 'react';

import type { HubModule, Hook } from '@xingternal/hub';

declare global {
  // eslint-disable-next-line @typescript-eslint/no-namespace
  namespace globalThis {
    // eslint-disable-next-line no-var
    var crate: { basePath: string };
  }
}
type LinkPropType = { to: string; children: React.ReactNode };
type LinkComponentType = React.ComponentType<LinkPropType>;
type LinkType =
  | LinkComponentType
  | React.FC<React.AnchorHTMLAttributes<HTMLAnchorElement>>;

// Default Link component
const SimpleLink = ({
  children,
  to,
  // eslint-disable-next-line node/no-unsupported-features/es-syntax
  ...props
}: LinkPropType): React.ReactElement => {
  return (
    <a href={to} {...props}>
      {children}
    </a>
  );
};

const LinkWithBasePath = ({
  children,
  to,
  ...props
}: LinkPropType): React.ReactElement => {
  const basePath =
    globalThis.crate.basePath === '/' ? '' : globalThis.crate.basePath;

  return (
    <Link to={`${basePath}${to}`} {...props}>
      {children}
    </Link>
  );
};

const isListed = (item: string, list?: string[]): boolean =>
  list !== undefined &&
  Boolean(
    list.find((listItem) => {
      //remove params for the match
      let url = listItem.split('?')[0];

      //ignore trailing slash
      url = url.length > 1 ? url.replace(/\/$/, '') : url;
      const pattern = `^${url.replace('/', '\\/')}(\\/.*)?(\\?.*)?$`;

      return new RegExp(pattern, 'i').test(item);
    })
  );

const getHooks = (useFrameHooks: Hook): Record<string, Hook> => {
  const useLinkComponent = (url: string | boolean): LinkType => {
    const { useFrameContext } = useFrameHooks();
    const { internalPaths } = useFrameContext();

    if (typeof url === 'string') {
      return isListed(url, internalPaths) ? LinkWithBasePath : SimpleLink;
    } else {
      return url ? LinkWithBasePath : SimpleLink;
    }
  };

  return { useLinkComponent };
};

type ReachLinkModule = HubModule & {
  getHooks: (
    useFrameHooks: () => Record<string, Hook>
  ) => Record<'useLinkComponent', (url: string | boolean) => LinkType>;
};

export const reachLinkModule: ReachLinkModule = { getHooks };
